import { callApi } from './api'

export function create (params) {
  const endpoint = `users/${params.userId}/orders`

  const config = {
    method: 'POST',
    body: { lineItems: [{ productSlug: params.productSlug }] },
    requiresAuth: true
  }
  return callApi(endpoint, config)
}


// WEBPACK FOOTER //
// ./src/services/api/orders.js